module.exports = __webpack_public_path__ + "img/goodperson_text.e775f817.png";